import React from 'react'
import { useFetcher } from 'libs/fetcher'
import EmptyContent from 'app/components/empty/EmptyContent'
import Panel from 'app/components/Panel'
import { FormattedMessage } from 'react-intl'

export default (props) => {
  const { title, apiFetcher, onSuccess } = props
  const { values, errors, isLoading } = useFetcher(apiFetcher, [])
  if (errors) {
    return (
      <Panel startText={title}>
        <EmptyContent
          descriptionLabel={<FormattedMessage id="error.default.label" />}
        />
      </Panel>
    )
  }

  return <>{isLoading ? null : onSuccess(values)}</>
}
